import { render, staticRenderFns } from "./overduemsg.html?vue&type=template&id=3330a65a&scoped=true&"
import script from "./overduemsg.js?vue&type=script&lang=js&"
export * from "./overduemsg.js?vue&type=script&lang=js&"
import style0 from "./overduemsg.sass?vue&type=style&index=0&id=3330a65a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3330a65a",
  null
  
)

component.options.__file = "overduemsg.vue"
export default component.exports